import { history } from 'instantsearch.js/es/lib/routers';
import { searchClient } from "../config/searchClient";
import { INSTANT_SEARCH_INDEX_NAME } from '../config/constants';
import { transformSearchItemToCategoryItem } from '../transform/searchItemToCategoryItem';
import {
  AisBreadcrumb,
  AisClearRefinements,
  AisConfigure,
  AisHierarchicalMenu,
  AisHits,
  AisInstantSearch,
  AisPagination,
  AisRefinementList,
  AisSearchBox,
  AisSortBy,
  AisStats,
  AisToggleRefinement,
  AisHighlight,
} from 'vue-instantsearch';
import { transformVersionToCountryFlag } from '../transform/versionToCountryFlag';
import customRouteStateMapping from '../transform/customRouteStateMapping';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';

Vue.component('kk-instant-search', {
  template: "#kk-instant-search",
  components: {
    AisInstantSearch,
    AisConfigure,
    AisSearchBox,
    AisBreadcrumb,
    AisHierarchicalMenu,
    AisToggleRefinement,
    AisRefinementList,
    AisClearRefinements,
    AisHits,
    AisSortBy,
    AisStats,
    AisPagination,
    AisHighlight,
  },
  props: {
    filters: String,
    initialUiState: Object,
  },
  data () {
    return {
      searchClient,
      indexName: INSTANT_SEARCH_INDEX_NAME,
      showMenu: false,
      showAdditionalFacets: false,
      routing: {
        router: history(),
        stateMapping: customRouteStateMapping(INSTANT_SEARCH_INDEX_NAME, this.initialUiState, this.filters),
      },
      middlewares: [
        createInsightsMiddleware({
          insightsClient: null,
        }),
      ],
      instantSearchInstance: null,
      facetStats: {},
      categoryHierarchy: [
        'category.lvl1',
        'category.lvl2',
        'category.lvl3',
        'category.lvl4',
        'category.lvl5',
        'category.lvl6'
      ],
      sortByValues: [
        { value: INSTANT_SEARCH_INDEX_NAME, label: 'Relevanz' },
        { value: `${INSTANT_SEARCH_INDEX_NAME}/sort/_preset:webshop-search-topseller`, label: 'Top Seller' },
        { value: `${INSTANT_SEARCH_INDEX_NAME}/sort/_preset:webshop-search-price-asc`, label: 'Preis aufsteigend' },
        { value: `${INSTANT_SEARCH_INDEX_NAME}/sort/_preset:webshop-search-price-desc`, label: 'Preis absteigend' },
        { value: `${INSTANT_SEARCH_INDEX_NAME}/sort/_preset:webshop-search-discount`, label: 'Reduzierung absteigend' },
        { value: `${INSTANT_SEARCH_INDEX_NAME}/sort/_preset:webshop-search-name-az`, label: 'Name A-Z' },
        { value: `${INSTANT_SEARCH_INDEX_NAME}/sort/_preset:webshop-search-name-za`, label: 'Name Z-A' },
        { value: `${INSTANT_SEARCH_INDEX_NAME}/sort/_preset:webshop-search-new`, label: 'Neu im Shop' },
        { value: `${INSTANT_SEARCH_INDEX_NAME}/sort/_preset:webshop-search-back-in-stock`, label: 'Wieder auf Lager' },
      ],
      priceSuggestions: [
        { label: 'unter 5€', value: [0, 5] },
        { label: 'unter 10€', value: [0, 10] },
        { label: '10-20€', value: [10, 20] },
        { label: '20-50€', value: [20, 50] },
        { label: '50-100€', value: [50, 100] },
        { label: 'über 1000€', value: [1000, Infinity] },
        { label: '100-200€', value: [100, 200] },
        { label: '200-500€', value: [200, 500] },
        { label: '500-1000€', value: [500, 1000] },
      ],
      showSkeleton: true,
      hierarchicalMenuSkeleton: [2, 4, 1, 2, 4, 3, 3, 2, 1, 4, 2, 1],
      facetSortBy: {
        default: ['isRefined', 'count:desc'],
      },
      facetIncludedAttributes: {
        min_price: ['min_price'],
        availability: ['availability'],
        condition: ['items.condition'],
        packaging: ['items.packaging'],
        type: ['type'],
        genre: ['genre'],
        system_manufacturer: ['system_manufacturer'],
        versions: ['versions'],
        color_groups: ['color_groups'],
        additional_features: ['is_graded', 'is_ips', 'is_import'],
        usk: ['usk'],
        languages: ['languages'],
      },
    };
  },
  methods: {
    searchFunction (helper) {
      this.scrollToTop();
      helper.search();
    },
    resetSearch () {
      $('#autocomplete-0-input').val('');
      this.instantSearchInstance.helper.setQuery('').setPage(0).search();
    },
    toValue (value, range) {
      return [
        typeof value.min === "number" ? value.min : range.min,
        typeof value.max === "number" ? value.max : range.max,
      ];
    },
    getItemCountryFlagSrc (item) {
      return transformVersionToCountryFlag(item.label);
    },
    sortItemsAlphanumeric (items, locale = 'de', collatorOptions = { sensitivity: 'base', numeric: true }) {
      return [...items].sort((a, b) => a.label.localeCompare(b.label, locale, collatorOptions));
    },
    sortItemsByCount (items) {
      return [...items].sort((a, b) => b.count - a.count);
    },
    sortItemsCustom (items, customOrder, defaultSortFn) {
      items = (defaultSortFn || this.sortItemsByCount)([...items]);

      return items.sort((a, b) => {
        const aIndex = customOrder.indexOf(a.label);
        const bIndex = customOrder.indexOf(b.label);

        if (aIndex === -1 && bIndex === -1) return 0;
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;

        return aIndex - bIndex;
      });
    },
    sortItemsAvailability (items) {
      return this.sortItemsCustom(items, [
        'Sofort lieferbar',
        'Lieferzeit 4-7 Tage',
        'Lieferzeit 1-2 Wochen',
        'Vorbestellung',
        'Ausverkauft'
      ]);
    },
    sortItemsCondition (items) {
      return this.sortItemsCustom(items, [
        'NEU & OVP',
        'NEU',
        'NEUWERTIG',
        'sehr guter Zustand',
        'gebraucht',
        'mit neuem Gehäuse',
        'akzeptabel',
        'starke Gebrauchsspuren',
      ]);
    },
    sortItemsType (items) {
      return this.sortItemsCustom(items, ['Spiele', 'Konsolen', 'Zubehör']);
    },
    sortItemsVersions (items) {
      return this.sortItemsCustom(items, ['DE Version', 'UK Version', 'JAP version', 'US Version']);
    },
    sortItemsPackaging (items) {
      return this.sortItemsCustom(items, ['mit OVP']);
    },
    sortItemsLanguages (items) {
      return this.sortItemsCustom(items, ['Deutsch', 'Englisch'])
    },
    filterItemsInStock (items) {
      return items.filter(({ value }) => value === 'Sofort lieferbar')
    },
    transformBreadcrumbItems (items, { results }) {
      const systemManufacturers = results._state.disjunctiveFacetsRefinements.system_manufacturer;
      const extendedItems = systemManufacturers?.length === 1
        ? [{ label: systemManufacturers[0], value: null }, ...items]
        : items;

      return extendedItems.map((item) => ({
        ...item,
        // Pop last Attribute, as the breadcrumbs by default point to the NEXT lower entry
        value: item.value ? item.value.split(' > ').slice(0, -1).join(' > ') : null
      })).map(this.routing.stateMapping.transformBreadcrumbItem);
    },
    toCategoryItem (item) {
      return transformSearchItemToCategoryItem(item, this.instantSearchInstance);
    },
    getSortIcon (value) {
      const [, facet = 'sales_rank', direction = 'desc'] = value.match(/(?!_)([^:),/]+):(asc|desc)/) ?? [];
      switch (facet) {
        case 'name':
          return `sort-alpha-${direction}`;
        case 'min_price':
        case 'max_price':
          return `sort-numeric-${direction}`;
        case 'sales_rank':
          return `sort-amount-${direction}`;
        case 'create_date':
        case 'new_in_stock':
          return `star`;
        case 'reference_saving_percent':
          return `percent`;
        default:
          return `sort-${direction}`;
      }
    },
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    hideSkeleton () {
      this.showSkeleton = false;
    },
    formatPrice (price) {
      return `${price.toFixed(2)} €`
    },
    listenToFilterScroll() {
      $('.ais-WidgetList__verticalList').on('scroll', function() {
        $(this).addClass('scrolled');
      });
    }
  },
  mounted () {
    this.instantSearchInstance = this.$refs.ais.instantSearchInstance;
    window.instantSearchInstance = this.instantSearchInstance;

    this.listenToFilterScroll();
  }
});
